import React from 'react';
import { PageHeader } from '../../components/ui/PageHeader';
import { PathChooser } from '../../components/shop/PathChooser';
import { Recommender } from '../../components/shop/Recommender';
import { useLanguage } from '../../contexts/LanguageContext';
export function Shop() {
  const {
    t
  } = useLanguage();
  return <>
      <PageHeader title={<>
            Build Your <span className="text-ice" data-id="element-1372" data-mp="2vp8gx8mlobl3">Lighting System.</span>
          </>} lead="Choose a professionally configured Complete Lighting System, or build your own with exactly the number of M1 PRO lights you need." data-id="element-1371" data-mp="280p6amg2vmpu" />
      <section className="mx-auto max-w-site px-5 py-12 md:px-8 md:py-16" data-id="element-1373" data-mp="2moima892sr8y">
        <PathChooser data-id="element-1374" data-mp="2qpvswkjzsygx" />
      </section>
      <section aria-labelledby="shop-rec" className="border-t mf-hairline bg-[#091C31]" data-id="element-1375" data-mp="2qou7bm5cotky">
        <div className="mx-auto max-w-site px-5 py-14 md:px-8 md:py-20" data-id="element-1376" data-mp="1b8bwg1enmfr9">
          <h2 id="shop-rec" className="font-display text-4xl font-semibold uppercase leading-[0.95] md:text-6xl" data-id="element-1377" data-mp="1fcjkdwdafrof">
            {t('rec.headline')}
          </h2>
          <div className="mt-10" data-id="element-1378" data-mp="2oc0xuugdpw7g">
            <Recommender data-id="element-1379" data-mp="2od2klw6rc750" />
          </div>
        </div>
      </section>
    </>;
}